import React from 'react';
import Modal from 'react-bootstrap/Modal';
import DanhSachKhachHangApi from "../../service/danhSachKhachHangApi";
import { pushNotification } from "utils/notifications";
class DeleteKhachHang extends React.Component {
  constructor(props) {
    super(props);
  }
 
  deleteKhachHang = () => () => {
    let props = this.props;
    if (props.CustomerID != undefined && props.CustomerID > 0) {
      DanhSachKhachHangApi.xoaKhachHang(props.CustomerID).then((response) => {
        if (response.data.Error == 0) {
          pushNotification(response.data.Message, "success", "TOP_CENTER", 2000);
          props.onSearch();
        }
        else {
          pushNotification(response.data.Message, "error", "TOP_CENTER", 2000);
        }
      });
    }
    props.onHide();
  };
  render() {
    let props = this.props;
    let { show, onHide } = props;
    return (
      <Modal
        show={show}
        size="modal-dialog modal-dialog"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modal-new modal fade text-left"
      >
        <Modal.Header>
          <h4 className="modal-title" id="myModalLabel16">
            <span className="btn-icon-right">
              <i className="mdi mdi-delete"></i>
            </span>
            Xác nhận xoá
          </h4>
          <button type="button" className="close-popup-new"
            onClick={onHide}
          >
            <i className="mdi mdi-close"></i>
          </button>
        </Modal.Header>
        <Modal.Body className="">
          <form className="form tat-toan form-horizontal">
            <div className="form-body">
              <div className="form-body">
                <div className="form-group row">
                  <label
                    className="col-md-12 label-control text-left"
                    for="projectinput2"
                  >
                    Bạn có chắc chắn muốn xóa không?
                  </label>
                </div>
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-new-main btn-checknew"
            onClick={this.deleteKhachHang()}
          >
            <span className="btn-icon-left">
              <i className="mdi mdi-check"></i>
            </span>
            Xác nhận
          </button>
          <button
            type="button"
            className="btn btn-new-main btn-closenew"
            onClick={onHide}
          >
            <span className="btn-icon-left">
              <i className="mdi mdi-close"></i>
            </span>
            Đóng
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}
export default DeleteKhachHang;
